import { defineMessages } from "react-intl";

export const messages = defineMessages({
  title: {
    defaultMessage: "Subscription Expired",
    id: "subscription-expired.title",
  },

  subtitle: {
    defaultMessage:
      "Your subscription has expired and access to Cayosoft Guardian has been suspended. Contact us to renew subscription.",
    id: "subscription-expired.subtitle",
  },

  tableTitle: {
    defaultMessage: "Subscription Details",
    id: "subscription-expired.tableTitle",
  },

  expiredOnLabel: {
    defaultMessage: "Expired on",
    id: "subscription-expired.expiredOnLabel",
  },

  daysOverdueLabel: {
    defaultMessage: "Days overdue",
    id: "subscription-expired.daysOverdueLabel",
  },

  daysOverdueValue: {
    defaultMessage: "{days, plural, one {# day} other {# days}}",
    id: "subscription-expired.daysOverdueValue",
  },

  contactCayosoft: {
    defaultMessage: "Contact Cayosoft",
    id: "subscription-expired.contactCayosoft",
  },

  needHelp: {
    defaultMessage: "Need help?",
    id: "subscription-expired.needHelp",
  },

  contactSupport: {
    defaultMessage: "Contact Support",
    id: "subscription-expired.contactSupport",
  },
});
